$(document).ready(function () {
    setMenuEvents();
    initLoginPage();
    initSettingsMenuReset();
});
function IsBlocked() {
    var current = parseInt($("#hdnCurrent").val() == null ? "0" : $("#hdnCurrent").val().toString());
    var limit = parseInt($("#hdnLimit").val() == null ? "0" : $("#hdnLimit").val().toString());
    //alert(current + ' - ' + limit);
    return current >= limit;
}
var setMenuEvents = function () {
    $('.selector--main-menu .nav-item').hover(function () {
        if ($(this).hasClass('nav-item-home')) {
            $('.sub-sidebar').addClass('invisible');
            return;
        }
        var submenu = $(this).data('submenu');
        if ($('.' + submenu).length == 0) {
            $('.sub-sidebar').addClass('invisible');
            return;
        }
        $('.sub-sidebar').removeClass('invisible');
        $('.nav-item-submenu').css('z-index', '1');
        $('.' + submenu).css('z-index', '100').hide().removeClass('d-none').show();
    }, function () {
        //if ($(this).find('.nav-link').hasClass('active')) {
        //    return;
        //}
        // $(this).find('.nav-link').removeClass('active');
        return;
        // var submenu = $(this).data('submenu');
        // $('.' + submenu).hide().addClass('d-none').css('z-index', '1');
    });
    $('.sidebar').hover(function () {
        return;
    }, function () {
        $('.nav-item-submenu').hide().addClass('d-none').css('z-index', '1');
        // $('.selector--main-menu .nav-link').removeClass('active');
        $('.sub-sidebar').addClass('invisible');
    });
    // set position of the home buttom
    // Menu/header/home-button/document height only change on resize or content change, not on
    // scroll -- cache them instead of re-reading (and looping over every nav-item) on every
    // scroll tick.
    var homeButtonMenuHeight = 0, homeButtonHeaderHeight = 0, homeButtonDocumentHeight = 0;
    var measureHomeButtonMetrics = function () {
        homeButtonMenuHeight = 0;
        $('.selector--main-menu .nav-item').each(function () {
            homeButtonMenuHeight += $(this).height();
        });
        homeButtonHeaderHeight = $('.header').height();
        homeButtonDocumentHeight = $(document).height();
    };
    var calculateHomeButtonPosition = function () {
        var windowHeight = $(window).height();
        var minPosition = homeButtonDocumentHeight - homeButtonMenuHeight - homeButtonHeaderHeight;
        var scrollTop = $(document).scrollTop();
        var windowBottom = homeButtonDocumentHeight - scrollTop - windowHeight;
        if (windowBottom > minPosition) {
            windowBottom = minPosition;
        }
        if (windowBottom < 0) {
            windowBottom = 0;
        }
        $('.nav-item-home').css('bottom', windowBottom + 'px');
    };
    // rAF-throttled: this handler was running the full read/write pass above at native scroll
    // event frequency (dozens of times/sec) on every page in the app.
    var homeButtonScrollTicking = false;
    $(document).scroll(function () {
        if (homeButtonScrollTicking) {
            return;
        }
        homeButtonScrollTicking = true;
        window.requestAnimationFrame(function () {
            calculateHomeButtonPosition();
            homeButtonScrollTicking = false;
        });
    });
    $(window).on('resize', measureHomeButtonMetrics);
    $(document).ready(function () {
        measureHomeButtonMetrics();
        calculateHomeButtonPosition();
    });
    $('a[href="/products/add"], a[href="/content/articles/add"], a[href="/content/events/add"]').on('click', function () {
        // check fullAccessModal
        //if ($('#fullAccessModal').length) {
        //    $('#fullAccessModal').modal('show');
        //    return false;
        //}
        if (IsBlocked()) {
            $('#fullAccessModal').modal('show');
            return false;
        }
    });
    calculateHomeButtonPosition();
};
var initLoginPage = function () {
    $('.form-signin .email-tooltip').hover(function () {
        if ($(this).find('.pop-over').length > 0)
            return;
        var popOver = '<div class="pop-over">Enter an email address that matches a listed contact on your account</div>';
        $(this).append($(popOver));
    }, function () {
        $(this).find('.pop-over').remove();
    });
    $('.form-signin').submit(function (e) {
        $("#ckbRememberMe").val($("#ckbRememberMe").prop("checked"));
    });
};
// initHelpFunction moved to Views/Shared/Partial/_HelpBox.cshtml (2026-08-07): the markup is
// now shared by _LayoutV4 and _OnboardingLayout, and the behaviour had to travel with it.
// Keeping a copy here as well would bind #help-form twice on panel pages.
var initSettingsMenuReset = function () {
    var $settingsMenu = $('.nav__menu.floatright');
    var $submenuCheckboxes = $settingsMenu.find('.nav__submenu-item input[type="checkbox"]');
    $settingsMenu.on('mouseenter', function () {
        $submenuCheckboxes.prop('checked', false);
    });
    $settingsMenu.find('.nav__menu-item.burger > input[type="checkbox"]').on('change', function () {
        if ($(this).is(':checked')) {
            $submenuCheckboxes.not(this).prop('checked', false);
        }
    });
};
/*******************Cookie************************/
function setCookie(cname, cvalue, ex) {
    var d = new Date();
    d.setTime(d.getTime() + (ex * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
/*******************A session that ended while the page was open**********************
 *
 * WHAT THIS REPLACES. A lead list loads once and then keeps asking for rows. Sessions end while it
 * is open -- they expire, or somebody signs out in another tab -- and the answer used to be a
 * redirect to the sign-in PAGE. The table followed it, got HTML where it wanted rows, and reported
 * the only thing it can:
 *
 *     DataTables warning: table id=invitedQuoteTable - Ajax error
 *
 * A browser dialog naming a table nobody has heard of, pointing at datatables.net, and identical to
 * what a real server fault produces -- so the same box appeared whether nothing was wrong or
 * everything was.
 *
 * The server answers an API call 401 now (Startup, OnRedirectToLogin), which is something a script
 * can act on. Acting on it means going where they were already going: sign in, and come back to
 * this page rather than to a generic one.
 *
 * 401 AND 403 ARE ACTED ON; everything else is SAID. A real fault still looks like a fault -- it
 * is never turned into a sign-in -- but it no longer looks like nothing. An audit on 30 Sep 2026
 * found most lead actions (Accept, Decline, Complete, Forward) and many saves handling success
 * only, so a 404, 409, 500 or a dropped connection left a spinner turning or a modal closed as if
 * it had worked. The fallback at the bottom names the problem and the next step, and stays quiet
 * when the caller has already said something.
 */
// Whether the page's own code has just shown a message for this failure. jQuery runs a request's
// own error callbacks before this global event, so a toast in the last moment is the caller's.
(function stampToasts() {
    var t = window.toastr;
    if (!t || t.__stamped) {
        return;
    }
    ['error', 'warning', 'info', 'success'].forEach(function (k) {
        var original = t[k];
        t[k] = function () {
            window.__lastToastAt = Date.now();
            return original.apply(t, arguments);
        };
    });
    t.__stamped = true;
})();
// Leaving the page cancels its requests; that is not a failure anybody needs to hear about.
window.addEventListener('pagehide', function () { window.__leavingPage = true; });
window.addEventListener('beforeunload', function () { window.__leavingPage = true; });
// A save, send, delete... -- anything but a plain load.
function isAction(settings) {
    return ((settings && settings.type) || 'GET').toUpperCase() !== 'GET';
}
// ONE PLAIN SENTENCE (user, 30 Sep 2026): status-by-status wording ("We couldn't find that. It may
// have been removed...") read as alarming and meant nothing to a supplier. What they need is whether
// their work stuck and what to do next. A business rule the server explains itself (a 400 or 409
// with a message, e.g. the last administrator cannot be removed) is still shown as said.
function messageForFailure(xhr, settings) {
    var body = xhr.responseJSON;
    var said = typeof body === 'string' ? body : (body && (body.message || body.msg)) || '';
    if ((xhr.status === 400 || xhr.status === 409)
        && said && typeof said === 'string' && said.charAt(0) !== '<' && said.length < 300) {
        return said;
    }
    if (xhr.status === 413) {
        return 'That file is too large.';
    }
    if (xhr.status === 0) {
        return isAction(settings)
            ? "Your changes weren't saved. Check your connection and try again."
            : "This didn't load. Check your connection and try again.";
    }
    return isAction(settings)
        ? "Your changes weren't saved. Refresh the page and try again."
        : "This didn't load. Refresh the page and try again.";
}
$(document).ajaxError(function (_event, xhr, settings, thrown) {
    if (!xhr) {
        return;
    }
    if (xhr.status === 401) {
        // Guarded, because several tables can be in flight at once and each failure fires this.
        if (window.__signInRedirectStarted) {
            return;
        }
        window.__signInRedirectStarted = true;
        var here = window.location.pathname + window.location.search;
        window.location.href = '/account/login?returnUrl=' + encodeURIComponent(here);
        return;
    }
    if (xhr.status === 403) {
        // Signed in, and not allowed. Sending them to sign in again would loop on a session that is
        // working perfectly -- what changed is what they may do, and only a person can resolve that.
        //
        // SAID ON THE PAGE, not by leaving it. This used to send the whole page to /error/403,
        // which drew "Something went wrong at our end": a Team Member at SBH Solutions got that
        // three times on 29 Sep 2026 for opening a colleague's email preferences. The server's
        // message says who to ask; a spinner the refused call left running is cleared with it.
        // One sentence for every refusal (user, 30 Sep 2026): whether their work stuck, and who to ask.
        var message = isAction(settings)
            ? "Your changes weren't saved. Ask an Administrator at your company to give you access."
            : "You don't have access to this. Ask an Administrator at your company to give you access.";
        var toastr_1 = window.toastr;
        if ($.fn.waitMe) {
            $('.waitMe_container').waitMe('hide');
        }
        if (!toastr_1) {
            window.location.href = '/account/accessdenied?returnUrl='
                + encodeURIComponent(window.location.pathname + window.location.search);
            return;
        }
        // Once per message a few seconds apart: several refused calls from one click would
        // otherwise stack the same sentence down the screen.
        var now = Date.now();
        if (window.__lastRefusal === message && now - (window.__lastRefusalAt || 0) < 4000) {
            return;
        }
        window.__lastRefusal = message;
        window.__lastRefusalAt = now;
        toastr_1.warning(message);
        return;
    }
    // ---- Everything else: say what happened and what to do -------------------------------
    // A cancelled request is not a failure, nor is one the browser dropped because the page was
    // navigating away.
    if (thrown === 'abort' || (xhr.status === 0 && window.__leavingPage)) {
        return;
    }
    // A load the page made by itself, with nobody watching a spinner for it, fails quietly as it
    // always did: a help panel or a thumbnail that did not arrive is not worth an alarm. Anything the
    // person did, or a load they were visibly waiting on, is told.
    var wasWaiting = $('.waitMe_container').length > 0;
    var isBackgroundLoad = ((settings && settings.type) || 'GET').toUpperCase() === 'GET' && !wasWaiting;
    // A spinner the failed call started would otherwise turn for good.
    if ($.fn.waitMe) {
        $('.waitMe_container').waitMe('hide');
    }
    if (isBackgroundLoad) {
        return;
    }
    var toastr = window.toastr;
    if (!toastr) {
        return;
    }
    // The page's own error handling already told them.
    if (Date.now() - (window.__lastToastAt || 0) < 250) {
        return;
    }
    var failure = messageForFailure(xhr, settings);
    var at = Date.now();
    if (window.__lastFailure === failure && at - (window.__lastFailureAt || 0) < 4000) {
        return;
    }
    window.__lastFailure = failure;
    window.__lastFailureAt = at;
    toastr.error(failure);
});
/*******************The dialog that says nothing*************************************
 *
 * DataTables ships with errMode "alert", and nothing here ever changed it. So every failed XHR --
 * including one the BROWSER cancelled because the page was navigating away -- raises
 *
 *     DataTables warning: table id=invitedQuoteTable - Ajax error.
 *     For more information about this error, please see http://datatables.net/tn/7
 *
 * A browser dialog, naming a table nobody has heard of, pointing at a library's website. Clicking
 * Logout, or any link, while a lead list is still drawing is enough to produce it, which is why it
 * has been reported as "some error on logout" and as a leads bug and looked unrelated both times.
 *
 * Logged rather than shown. A person cannot act on this: the two causes worth acting on are already
 * handled -- a dead session redirects to sign in (the 401 handler above), and a genuine fault is a
 * fault whether or not a dialog interrupts them. What is left is a cancelled request, which is not
 * an error at all.
 *
 * THE COST, stated rather than left to be found: a real server fault now leaves the table as it was
 * with a line in the console, instead of an alert. That is a worse signal for a developer and a
 * better one for everybody else, and the console is where the detail was always going to be.
 *
 * Applied twice because script order is not guaranteed: once now, in case DataTables is already
 * loaded, and once on ready for the pages that load it after this file.
 */
function quietenDataTables() {
    var dt = $.fn && $.fn.dataTable;
    if (!dt || !dt.ext) {
        return false;
    }
    dt.ext.errMode = function (_settings, _helpPage, message) {
        if (window.console && console.error) {
            console.error('DataTables: ' + message);
        }
    };
    return true;
}
if (!quietenDataTables()) {
    $(function () { quietenDataTables(); });
}
/**
 * The Products pages' preview pop-up (#previewModel), 27 Oct 2026. The page opens in the pop-up's frame
 * with a loading line over it until it arrives, so a blank box never looks stuck; after 6 seconds the
 * line says the page is slow and points at "Open in a new tab". Used by the product list's eye and by
 * Save & Preview on the add/edit pages. A product with no page yet says so instead of loading nothing.
 */
var productPreviewToken = 0;
function OMAShowProductPreview(url) {
    var $modal = $('#previewModel');
    var $frame = $modal.find('iframe');
    var $body = $modal.find('.modal-body').css('position', 'relative');
    var $cover = $body.find('.oma-preview-loading');
    if (!$cover.length) {
        $cover = $('<div class="oma-preview-loading" role="status" style="position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;padding:24px;background:#fff;text-align:center;color:#434343;font-size:15px;">'
            + '<p class="oma-preview-status" style="margin:0;"></p></div>').appendTo($body);
        $modal.find('.modal-title').after('<a class="oma-preview-newtab" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;gap:6px;margin-left:auto;margin-right:12px;align-self:center;font-size:14px;color:#434343;text-decoration:underline;">'
            + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3"/></svg>Open in a new tab</a>');
        $modal.on('hidden.bs.modal', function () { productPreviewToken++; $frame.attr('src', 'about:blank'); });
    }
    var token = ++productPreviewToken;
    var $status = $cover.find('.oma-preview-status');
    $frame.height($(window).height() * 75 / 100);
    $cover.css('display', 'flex');
    if (!url) {
        $modal.find('.oma-preview-newtab').hide();
        $status.text('This product has no page to preview yet. Add a picture to put it live, then preview it.');
        $frame.attr('src', 'about:blank');
        $modal.modal('show');
        return;
    }
    $modal.find('.oma-preview-newtab').attr('href', url).show();
    $status.text('Loading preview…');
    var slow = window.setTimeout(function () {
        if (token === productPreviewToken)
            $status.text('This page is taking a while to load. Keep waiting, or open it in a new tab.');
    }, 6000);
    $frame.off('load.preview').on('load.preview', function () {
        if (token !== productPreviewToken || this.getAttribute('src') === 'about:blank')
            return;
        clearTimeout(slow);
        $cover.css('display', 'none');
    }).attr('src', url);
    $modal.modal('show');
}
